import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  LIST: 'LIST_BUILDING_TYPE',
};

export const listBuildingType = () => {
  return {
    type: ACTION.LIST,
    payload: RestClient.request({
      method: 'get',
      url: Constants.API_BUILDING_TYPE,
    })
      .then(resp => resp.data)
      .catch(err => Promise.reject(err.response.data.detail)),
  };
};



// WEBPACK FOOTER //
// ./src/redux/building_type/building_type_actions.js